import React from "react";
import {MallContext} from '../providers';

function useMall() {
    return React.useContext(MallContext);
}

export {useMall}
